import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  for: "artifact-score-formula",
  class: "toggle-switch header"
}
const _hoisted_3 = { value: "-1" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "formula-detail" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "formula-detail" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          id: "artifact-score-formula",
          type: "checkbox",
          class: "hidden",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expanded) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.expanded]
        ]),
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.displayName('聖遺物スコア計算式')), 1),
        _withDirectives(_createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIndex) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectOnChange && _ctx.selectOnChange(...args)))
          }, [
            _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.artifactScoreFormulaName(_ctx.currentFormula)), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artifactScoreFormulaList, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: index
              }, "   " + _toDisplayString(_ctx.artifactScoreFormulaName(item)), 9, _hoisted_4))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedIndex]
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentFormula, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "right",
                key: index
              }, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.displayName(item[0])) + " × ", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    "onUpdate:modelValue": ($event: any) => ((item[1]) = $event),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changed = true))
                  }, null, 40, _hoisted_6), [
                    [_vModelText, item[1]]
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              disabled: !_ctx.changed,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyFormula && _ctx.applyFormula(...args)))
            }, "Apply", 8, _hoisted_8)
          ])
        ], 512), [
          [_vShow, _ctx.expanded]
        ])
      ]))
    : _createCommentVNode("", true)
}